<template>
  <div
    class="d-signup-modal modal modal-sm sign-up-modal"
    :class="{ 'active': isShown }"
  >
    <div class="overlay" />
    <div
      class="modal-content"
    >
      <a
        class="button button-icon button-close button-close-modal"
        @click="hide()"
      />

      <div class="modal-image">
        <img
          :src="images.header"
          :height="dimensions.height"
          :width="dimensions.width"
        >
      </div>
      <div class="modal-body">
        <DSignupModalSignup />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import DSignupModalSignup from './d-signup-modal-signup/d-signup-modal-signup.vue';

import GREAT_STORY_IMG from '@d-assets/great-story.svg';
import { IMAGE_DIMENSIONS } from '@d-shared/config';

export default {
  components: {
    DSignupModalSignup,
  },
  data: () => ({
    images: {
      header: GREAT_STORY_IMG,
    },
    isShown: false,
    dimensions: IMAGE_DIMENSIONS.signupModalImage,
  }),
  methods: {
    hide() {
      this.$set(this, 'isShown', false);
    },

    show() {
      this.$set(this, 'isShown', true);
    },
  },
};
</script>
